import _str from "shared/util/_str";
import { PRODUCT_SUBTYPES } from "shared/payment/constants";
import { formatProductName } from "shared/payment/helpers/processProduct";

const PRODUCT_SUBTYPE_TO_TEXT_MAP = {
	[PRODUCT_SUBTYPES.READ_RECEIPT]: {
		SINGULAR: _str("Read Receipt"),
		PLURAL: _str("Read Receipts"),
	},
	[PRODUCT_SUBTYPES.STACK_PASS]: {
		SINGULAR: _str("Stack Pass"),
		PLURAL: _str("Stack Passes"),
	},
};

export function formatGraphQLProductInfoForLegacy(product) {
	const { productSubType, productType, subPeriod } = product;
	const pluralText = PRODUCT_SUBTYPE_TO_TEXT_MAP[productSubType].PLURAL;
	const singularText = PRODUCT_SUBTYPE_TO_TEXT_MAP[productSubType].SINGULAR;

	const name = formatProductName({
		productType,
		productSubtype: productSubType,
		subPeriod,
		tokensNumber: product.tokensCount,
	});
	const salesTax = product.initialTaxes.find((tax) => tax.taxType === "SALES");

	return {
		...product,
		name,
		formattedSalesTaxes: (salesTax || {}).formattedAmount || null,
		unitName: singularText,
		unitNamePlural: pluralText,
		productSubtype: product.productSubType,
		productid: product.productId,
		tokensNumber: product.tokensCount,
	};
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/formatGraphQLProductInfoForLegacy.js